(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kuvings-color-shift-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ticking = false;

    function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

    function update(el) {
      var trigger = el.querySelector('[data-kv-sc-trigger]');
      if (!trigger) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var top = trigger.getBoundingClientRect().top;

      // Progress is 0 while the text block is below "start" (% of viewport height),
      // 1 once it has moved above "end".
      var start = (parseFloat(el.getAttribute('data-start')) || 60) / 100 * vh;
      var end = (parseFloat(el.getAttribute('data-end')) || 25) / 100 * vh;
      var p = start === end ? (top <= end ? 1 : 0) : clamp((start - top) / (start - end), 0, 1);

      el.style.setProperty('--kv-p', p.toFixed(3));
    }

    function updateAll() {
      ticking = false;
      var list = document.querySelectorAll('[data-kv-sc]');
      for (var i = 0; i < list.length; i++) update(list[i]);
    }

    function request() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateAll);
    }

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    window.addEventListener('load', request);
    document.addEventListener('shopify:section:load', request);
    request();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kuvings-faq-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.kvInit) return;
      root.dataset.kvInit = '1';
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));

      function select(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }

      tabs.forEach(function (tab, i) {
        tab.tabIndex = i === 0 ? 0 : -1;
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (e) {
          var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!dir) return;
          e.preventDefault();
          var next = tabs[(i + dir + tabs.length) % tabs.length];
          next.focus();
          select(next);
        });
      });
    }
    function boot() { document.querySelectorAll('[data-kv-faq]').forEach(init); }
    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kuvings-fullbleed-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var ticking = false;

    function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

    function update(el) {
      var media = el.querySelector('[data-kv-fb-media]');
      if (!media) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;

      if (reduce.matches) {
        media.style.transform = '';
        media.style.opacity = '';
        return;
      }

      var amp = parseFloat(el.getAttribute('data-parallax')) || 0;
      var fade = parseFloat(el.getAttribute('data-fade')) || 0;

      // 0 when the section's top touches the viewport bottom, 1 when its bottom leaves the viewport top
      var p = clamp((vh - r.top) / (vh + r.height), 0, 1);
      var shift = (0.5 - p) * 2 * (amp / 100) * r.height;      // +amp -> -amp, in px
      var dist = Math.abs(p - 0.5) * 2;                          // 0 in the middle, 1 at the edges
      var opacity = 1 - fade * dist * dist;

      media.style.transform = 'translate3d(0,' + shift.toFixed(2) + 'px,0)';
      media.style.opacity = opacity.toFixed(3);
    }

    function updateAll() {
      ticking = false;
      var list = document.querySelectorAll('[data-kv-fb]');
      for (var i = 0; i < list.length; i++) update(list[i]);
    }

    function request() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateAll);
    }

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    window.addEventListener('load', request);
    document.addEventListener('shopify:section:load', request);
    if (reduce.addEventListener) reduce.addEventListener('change', request);
    request();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kuvings-juice-pack-global"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var observer = null;

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -15% 0px', threshold: 0 });
    }

    function initJuicePack(root) {
      if (!root || root.__kvPjInit) return;
      root.__kvPjInit = true;

      var shell = root.querySelector('[data-kv-packs-block]');
      var stage = shell && shell.querySelector('[data-kv-stage]');

      if (!shell || !stage) {
        if (observer) observer.observe(root); else root.classList.add('is-in');
        return;
      }

      var ART = 1500;
      var PACK_W = 176;
      var imgSrc = shell.dataset.src || '';
      var rowsConfig = [6, 6, 5, 5];
      var ROWS = [
        { y: 828, scale: 1.26, gap: 236, z: 40 },
        { y: 665, scale: 1.10, gap: 216, z: 30 },
        { y: 530, scale: 0.97, gap: 194, z: 20 },
        { y: 418, scale: 0.86, gap: 176, z: 10 }
      ];

      function renderPacks() {
        Array.prototype.forEach.call(stage.querySelectorAll('.kv-pj__pack'), function (el) { el.remove(); });

        rowsConfig.forEach(function (count, r) {
          var rd = ROWS[r] || ROWS[ROWS.length - 1];
          var left = (ART - PACK_W) / 2 - ((count - 1) * rd.gap) / 2;

          for (var c = 0; c < count; c++) {
            var pack = document.createElement('div');
            pack.className = 'kv-pj__pack';
            pack.style.zIndex = rd.z;

            if (imgSrc) {
              var img = document.createElement('img');
              img.src = imgSrc;
              img.alt = '';
              img.decoding = 'async';
              img.draggable = false;
              pack.appendChild(img);
            }

            var finalX = left + c * rd.gap;
            var finalY = rd.y;
            var center = (count - 1) / 2;
            var side = c < center ? -1 : 1;
            var startX = side < 0 ? -PACK_W - 92 : ART + PACK_W + 120;
            var pairIndex = Math.min(c, count - 1 - c);
            var delay = (rowsConfig.length - 1 - r) * 105 + pairIndex * 72;

            pack.style.setProperty('--fx', finalX + 'px');
            pack.style.setProperty('--fy', finalY + 'px');
            pack.style.setProperty('--fs', rd.scale);
            pack.style.setProperty('--delay', delay + 'ms');

            stage.appendChild(pack);
          }
        });
      }

      function resizeArt() {
        var art = shell.querySelector('.kv-pj__art');
        if (!art) return;
        art.style.transform = 'scale(' + ((shell.clientWidth || ART) / ART) + ')';
      }

      if ('ResizeObserver' in window) {
        new ResizeObserver(resizeArt).observe(shell);
      } else {
        window.addEventListener('resize', resizeArt, { passive: true });
      }

      renderPacks();
      resizeArt();

      if (observer) observer.observe(root); else root.classList.add('is-in');
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-kv-pj]');
      for (var i = 0; i < roots.length; i++) initJuicePack(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kuvings-juice-pack"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var observer = null;

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -15% 0px', threshold: 0 });
    }

    function initJuicePack(root) {
      if (!root || root.__kvPjInit) return;
      root.__kvPjInit = true;

      var shell = root.querySelector('[data-kv-packs-block]');
      var stage = shell && shell.querySelector('[data-kv-stage]');
      var copy = root.querySelector('[data-kv-copy]');
      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-kv-unit]'));
      var copyUnits = Array.prototype.slice.call(root.querySelectorAll('[data-kv-copy-unit]'));
      var noteUnits = Array.prototype.slice.call(root.querySelectorAll('[data-kv-note-unit]'));

      // Nothing to animate without the right area: just reveal the text
      if (!shell || !stage || !buttons.length) {
        if (observer) observer.observe(root); else root.classList.add('is-in');
        return;
      }

      var ART = 1500;
      var PACK_W = 176;
      var CONFIGS = {
        ml: { src: shell.dataset.mlSrc || '', rows: [6, 6, 5, 5] },
        oz: { src: shell.dataset.ozSrc || '', rows: [5, 5, 5, 4] }
      };
      var ROWS = [
        { y: 828, scale: 1.26, gap: 236, z: 40 },
        { y: 665, scale: 1.10, gap: 216, z: 30 },
        { y: 530, scale: 0.97, gap: 194, z: 20 },
        { y: 418, scale: 0.86, gap: 176, z: 10 }
      ];
      var packs = [];
      var unitTextTimer = null;

      function renderPacks(unit) {
        var cfg = CONFIGS[unit];
        Array.prototype.forEach.call(stage.querySelectorAll('.kv-pj__pack'), function (el) { el.remove(); });
        packs = [];

        cfg.rows.forEach(function (count, r) {
          var rd = ROWS[r] || ROWS[ROWS.length - 1];
          var left = (ART - PACK_W) / 2 - ((count - 1) * rd.gap) / 2;

          for (var c = 0; c < count; c++) {
            var pack = document.createElement('div');
            pack.className = 'kv-pj__pack';
            pack.style.zIndex = rd.z;

            if (cfg.src) {
              var img = document.createElement('img');
              img.src = cfg.src;
              img.alt = '';
              img.decoding = 'async';
              img.draggable = false;
              pack.appendChild(img);
            }

            var finalX = left + c * rd.gap;
            var finalY = rd.y;
            var center = (count - 1) / 2;
            var isCenter = Number.isInteger(center) && c === center;
            var side = isCenter ? (r % 2 === 0 ? -1 : 1) : (c < center ? -1 : 1);
            var startX = side < 0 ? -PACK_W * 0.92 : ART + PACK_W * 0.12;
            var pairIndex = Math.min(c, count - 1 - c);
            var delay = (cfg.rows.length - 1 - r) * 105 + pairIndex * 72;

            pack.style.setProperty('--fx', finalX + 'px');
            pack.style.setProperty('--fy', finalY + 'px');
            pack.style.setProperty('--fs', rd.scale);
            pack.style.setProperty('--delay', delay + 'ms');
            pack.style.transform = 'translate3d(' + startX + 'px, ' + (finalY + 8) + 'px, 0) scale(' + (rd.scale * 0.96) + ')';

            stage.appendChild(pack);
            packs.push(pack);
          }
        });
      }

      function resizeArt() {
        var art = shell.querySelector('.kv-pj__art');
        if (!art) return;
        art.style.transform = 'scale(' + ((shell.clientWidth || ART) / ART) + ')';
      }

      if ('ResizeObserver' in window) {
        new ResizeObserver(resizeArt).observe(shell);
      } else {
        window.addEventListener('resize', resizeArt, { passive: true });
      }

      function restartAnimation() {
        packs.forEach(function (pack) {
          pack.style.animation = 'none';
          void pack.offsetWidth;
          pack.style.animation = '';
        });
        var sheen = shell.querySelector('.kv-pj__sheen');
        if (sheen) {
          sheen.style.animation = 'none';
          void sheen.offsetWidth;
          sheen.style.animation = '';
        }
      }

      function switchContent(unit) {
        copyUnits.forEach(function (item) { item.hidden = item.dataset.kvCopyUnit !== unit; });
        noteUnits.forEach(function (item) { item.hidden = item.dataset.kvNoteUnit !== unit; });
      }

      function applyUnit(unit) {
        shell.dataset.unit = unit;
        renderPacks(unit);
        resizeArt();
        switchContent(unit);
        buttons.forEach(function (btn) {
          var active = btn.dataset.kvUnit === unit;
          btn.classList.toggle('active', active);
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        restartAnimation();
      }

      function setUnit(unit, animateText) {
        if (animateText === undefined) animateText = true;
        if (shell.dataset.unit === unit && animateText) return;
        clearTimeout(unitTextTimer);

        if (!animateText || !copy) { applyUnit(unit); return; }

        copy.classList.add('unit-text-switching');
        unitTextTimer = setTimeout(function () {
          applyUnit(unit);
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { copy.classList.remove('unit-text-switching'); });
          });
        }, 240);
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          setUnit(btn.dataset.kvUnit);
        });
      });

      setUnit('ml', false);

      // Start the entrance (text fade-up + packs) when the section scrolls into view
      if (observer) observer.observe(root); else root.classList.add('is-in');
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-kv-pj]');
      for (var i = 0; i < roots.length; i++) initJuicePack(roots[i]);
    }

    // The script can run before the markup exists, so wait for the DOM
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kuvings-media-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var observer = null;

    function reveal(row) { row.classList.add('is-in'); }

    function bindRows(root) {
      var rows = (root || document).querySelectorAll('[data-kv-mt] .kv-mt__row');
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        if (row.__kvAnimBound) continue;
        row.__kvAnimBound = true;
        // No observer support: show everything right away
        if (!observer) { reveal(row); continue; }
        observer.observe(row);
      }
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var row = entry.target;
          var section = row.closest('[data-kv-mt]');
          var replay = section && section.getAttribute('data-replay') === 'true';
          if (entry.isIntersecting) {
            reveal(row);
            if (!replay) observer.unobserve(row);
          } else if (replay) {
            row.classList.remove('is-in');
          }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });
    }

    function init(root) { bindRows(root); }

    // The script can run before the markup exists, so wait for the DOM
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
